import React, { useContext } from "react";
import { DeviceUsersList } from "./List/DeviceUsersList";
import { SelectedTenantContext } from "polyrouter/SelectedTenantProvider";

export const DeviceUsers: React.FC = () => {
  const { tenant } = useContext(SelectedTenantContext);
  return <>{tenant && <DeviceUsersList tenant={tenant} />}</>;
};

export default DeviceUsers;
